import { Row, Container, Col } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

export default function BenefitsOfHosting() {
  return (
    <Row className="mx-auto">
      <Container className="p-5">
        <h3 className="h2 pb-5 text-center">Why Join Skyhook</h3>
        <Row>
          <Col sm={12} lg={6}>
            <div className="d-flex w-100">
              <div className="p-3">
                <FaCheckCircle className="text-dark" size="5rem" />
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Find new customers</span>
                  <p className="mb-1">
                    Hussain found over 1000 trekkers for his <em>Mt Toubkal</em>{' '}
                    adventure in Morocco, in his second year of working with
                    Skyhook.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} lg={6}>
            <div className="d-flex w-100">
              <div className="p-3">
                <FaCheckCircle className="text-dark" size="5rem" />
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Manage your bookings</span>
                  <p className="mb-1">
                    Jakob receives flight information and medical details from
                    each customer for his <em>Beginners Ice Climbing</em> trip
                    in Norway.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} lg={6}>
            <div className="d-flex w-100">
              <div className="p-3">
                <FaCheckCircle className="text-dark" size="5rem" />
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Make your trips beautiful</span>
                  <p className="mb-1">
                    Showcase your incredible adventures with a beautiful page
                    for each trip.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} lg={6}>
            <div className="d-flex w-100">
              <div className="p-3 h1">
                <FaCheckCircle className="text-dark" size="5rem" />
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Get fantastic reviews</span>
                  <p className="mb-1">
                    Build up great reviews from verified customers - watch how
                    it helps your business grow!
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Row>
  );
}
